export const apiUrl = "https://apiv2.burhaninatural.com/api/admin";
// export const apiUrl = "https://api.laconicmarketing.in/api/admin";
